import { injectable } from 'inversify';
import Long from 'long'
import { Message, Field, Type } from "protobufjs/light";
import { QuizSessionQuestionTimesState } from '../../../api'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';

@injectable()
export class QuizSessionQuestionTimesStateProtobufMapper {

  map(input: QuizSessionQuestionTimesState): QuizSessionQuestionTimeStateProtoMessage[] {
    return input.map(item => {

      if (item === null) {
        return new QuizSessionQuestionTimeStateProtoMessage()
      }

      return new QuizSessionQuestionTimeStateProtoMessage({
        firstShownTime: ProtobufSerializer.serializeDate(item.firstShownTime),
        seconds: item.seconds
      })
    })
  }
  
  unmap(input: QuizSessionQuestionTimeStateProtoMessage[]): QuizSessionQuestionTimesState {
    return input.map(item => {

      if (item.firstShownTime.eq(0)) {
        return null
      }

      return {
        firstShownTime: ProtobufSerializer.deserializeDate(item.firstShownTime),
        seconds: item.seconds
      }
    })
  }
}

@Type.d('QuizSessionQuestionTimeStateProtoMessage')
export class QuizSessionQuestionTimeStateProtoMessage extends Message<QuizSessionQuestionTimeStateProtoMessage> {

  @Field.d(1, 'uint64', "optional", 0)
  firstShownTime: Long

  @Field.d(2, 'uint32', "optional", 0)
  seconds: number
}
